module.exports = __webpack_public_path__ + "img/1f913.50edf05.svg";